function handleError(error) {
  let message;
  if (error.response) {
    if (error.response.status === 401) {
      window.location.href = '/unauthorized';
      return;
    }

    message = error.response.error || 'Internal server error';
  }
  else if (error.request) message = 'No response received';
  else if (error.message) message = error.message;
  else message = 'Unknown error';
  alert(message);  // TODO
}

function isEmptyObject(obj) {
  return Object.keys(obj).length === 0;
}

function getDateTime(datetime) {
  const day = datetime.substr(8, 2);
  const month = datetime.substr(5, 2);
  const year = datetime.substr(0, 4);
  const hour = datetime.substr(11, 2);
  const minute = datetime.substr(14, 2);
  const second = datetime.substr(17, 2);
  return day + '.' + month + '.' + year + ' ' + hour + ':' + minute + ':' + second;
}

const USER_TYPES = ['admin', 'user'];

export {
  handleError,
  isEmptyObject,
  getDateTime,
  USER_TYPES
};